import SelfStudyIcon from "../../../images/self_study.png";
import CrashCourseIcon from "../../../images/eam_crashcourse.png";
import StudyPlansIcon from "../../../images/registrations/plan.png";
import SpecialPlansIcon from "../../../images/paper-plan.png";

// Plan group images (student_plans_grouping.image_path) pointed at rizee.in/static_content_images,
// which no longer serves them. Use bundled icons for those files, and fall back on load errors.
const LOCAL_PLAN_ICONS = {
    "self_study_plan1.png": SelfStudyIcon,
    "crash_course_plan1.png": CrashCourseIcon,
    "study_plans_1.png": StudyPlansIcon,
    "special_plans.png": SpecialPlansIcon,
};

export const getPlanIcon = (imagePath) => {
    if (!imagePath) return SelfStudyIcon;
    const fileName = imagePath.split("/").pop().toLowerCase();
    return LOCAL_PLAN_ICONS[fileName] || imagePath;
};

export const onPlanIconError = (e) => {
    if (e.target.src.indexOf(SelfStudyIcon) === -1) e.target.src = SelfStudyIcon;
};
